<template>
  <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
    <div
      class="
        intro-y
        col-span-12
        flex flex-wrap
        items-center
        mt-2
      "
    >
      
      <div class="my-5">
        <strong><h2>Filter by domain</h2></strong>
        <button class="button shadow-md m-3.5" @click="filterAll()">All</button>
        <button
        class="button shadow-md mr-2"
        v-for="d in domains"
        @click="filterDomain(d)"
        :key="d"
      >
        {{ d }}
      </button>
      </div>
      
      <div class="my-5">
        <strong><h2>Filter by subject</h2></strong>
        <button
        class="button shadow-md mr-2"
        v-for="d in subjects"
        @click="filterSubject(d)"
        :key="d"
      >
        {{ d }}
      </button>
      </div>
    </div>
    <div class="my-5">
        <strong><h2>Filter by Usage Metric</h2></strong>
        <button
        class="button shadow-md mr-2"
        v-for="d in usageMetrics"
        @click="filterUsageMetric(d)"
        :key="d"
      >
        {{ d }}
      </button>
      </div>
    <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
        <div class="w-56 relative text-gray-700 dark:text-gray-300">
          <input
            @input="search"
            type="text"
            v-model="searchData"
            class="input w-56 box pr-10 placeholder-theme-13"
            placeholder="Search..."
          />
          <SearchIcon class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0" />
        </div>
      </div>
    <div
      class="
        intro-y
        col-span-12
        flex flex-wrap
        sm:flex-no-wrap
        items-center
        mt-2
      "
    >
      <button
        class="button bg-blue-800 text-white mt-2 shadow-md mr-2"
        @click="sortAvg(0)"
      >
        Sort By Avg (asc)
      </button>
      <button
        class="button bg-blue-800 text-white mt-2 shadow-md mr-2"
        @click="sortAvg(1)"
      >
        Sort By Avg (dsc)
      </button>
      <button
        class="button bg-blue-800 text-white mt-2 shadow-md mr-2"
        @click="sortSub(0)"
      >
        Sort By Submissions (asc)
      </button>
      <button
        class="button bg-blue-800 text-white mt-2 shadow-md mr-2"
        @click="sortSub(1)"
      >
        Sort By Submissions (dsc)
      </button>

    </div>
    <div style="padding-top: 20px">
      <input
        type="text"
        v-model="from"
        class="input w-56 box pr-10 placeholder-theme-13"
        placeholder="From"
      />
      <input
        type="text"
        v-model="to"
        class="input w-56 box pr-10 placeholder-theme-13"
        placeholder="To"
      />
      <button class="button shadow-md mr-2" @click="getAnalyticsByInterval()">
        Filter by interval
      </button>
    </div>

    <!-- new code -->
    <div class="col-span-6 sm:col-span-6 xxl:col-span-3 intro-y mt-8">
      <div class="box p-5">
        <div>
          <div class="text-lg font-bolder truncate text-center">Total Data</div>
          <div class="grid grid-cols-5 gap-2 pt-2 px-6">
            <div class="flex flex-col text-huge mt-1 font-medium">
              {{ totalData.total_quizzes }}
              <h3>Quizzes</h3>
            </div>
            <div class="flex flex-col text-huge mt-1 font-medium">
              {{ totalData.total_clicks }}
              <h3>Clicks</h3>
            </div>
            <div class="flex flex-col text-huge mt-1 font-medium">
              {{ totalData.total_attempted }}
              <h3>Attempted</h3>
            </div>
            <div class="flex flex-col text-huge mt-1 font-medium">
              {{ totalData.total_completed }}
              <h3>Completed</h3>
            </div>
            <div class="flex flex-col text-huge mt-1 font-medium">
              {{ totalData.total_emails }}
              <h3>Unique Emails</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vue-json-to-csv
      :json-data="analytics"
      :labels="{ quiz_title: { title: 'Title' }, domain:{ title:'Domain'}, quiz_subject:{title:'Subject'}, count_sessions:{title:'Clicks'}, 
      attempted:{title:'Attempted'},  completed:{title:'Completed'}, number_of_emails:{title:'Uniqe Emails'}}"
      csv-title="data"
    >
      <button class="button bg-blue-800 text-white mt-2 shadow-md mr-2">
        <b>Download data</b>
      </button>
    </vue-json-to-csv>
    <!-- new code -->
    <div class="col-span-12 grid grid-cols-12 gap-6 mt-8">
      <div
        class="col-span-12 sm:col-span-6 xxl:col-span-3 intro-y"
        v-for="(q, i) in analytics"
        :key="i"
      >
        <div class="box p-5 zoom-in">
          <div class="flex items-center">
            <div class="w-2/4 flex-none">
              <div class="text-lg font-medium truncate">{{ q.quiz_title }}</div>
              <div class="text-gray-600 mt-1">{{ q.domain }}</div>
              <div class="text-huge mt-1 font-medium">
                {{ q.count_sessions }} Clicks
              </div>
              <div class="text-huge mt-1 font-medium">
                {{ q.attempted }} Attempted
              </div>
              <div class="text-huge mt-1 font-medium">
                {{ q.completed }} Completed
              </div>
              <div class="text-huge mt-1 font-medium">
                {{ q.number_of_emails }} Unique emails
              </div>
            </div>
            <div class="flex-none ml-auto relative">
              <div class="chartjs-size-monitor">
                <div class="chartjs-size-monitor-expand">
                  <div class=""></div>
                </div>
                <div class="chartjs-size-monitor-shrink">
                  <div class=""></div>
                </div>
              </div>
              <canvas
                id="report-donut-chart-1"
                width="90"
                height="90"
                class="chartjs-render-monitor"
                style="display: block"
              ></canvas>
              <div
                class="
                  font-medium
                  absolute
                  w-full
                  h-full
                  flex
                  items-center
                  justify-center
                  top-0
                  left-0
                "
              >
                Average: {{ ((q.average / q.total_score) * 100).toFixed(2) }}%
              </div>
            </div>
            <div class="flex-none ml-auto relative">
              <div class="chartjs-size-monitor">
                <div class="chartjs-size-monitor-expand">
                  <div class=""></div>
                </div>
                <div class="chartjs-size-monitor-shrink">
                  <div class=""></div>
                </div>
              </div>
              <canvas
                id="report-donut-chart-1"
                width="90"
                height="90"
                class="chartjs-render-monitor"
                style="display: block"
              ></canvas>
              <div
                class="
                  font-medium
                  absolute
                  w-full
                  h-full
                  flex
                  items-center
                  justify-center
                  top-0
                  left-0
                "
              >
                {{ q.average }} / {{ q.total_score }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueJsonToCsv from "vue-json-to-csv";
export default {
  name: "UTableVue",
  components: {
    // Button
    // Uploader
    VueJsonToCsv
  },
  data() {
    return {
      analytics: {},
      domains: [],
      subjects: [],
      absoluteData: [],
      usageMetrics:[],
      searchData: "",
      from:"",
      to:"",
      totalData: {},
    };
  },
  created() {
    this.getAnalytics();
    this.getTotalAnalyticsData();
  },
  methods: {
    sortAvg(n) {
      if (n === 0) {
        this.analytics.sort(
          (a, b) => a.average / a.total_score - b.average / b.total_score
        );
      } else if (n === 1) {
        this.analytics.sort(
          (a, b) => b.average / b.total_score - a.average / a.total_score
        );
      }
    },
    sortSub(n) {
      if (n === 0) {
        this.analytics.sort((a, b) => a.count_sessions - b.count_sessions);
      } else if (n === 1) {
        this.analytics.sort((a, b) => b.count_sessions - a.count_sessions);
      }
    },
    search() {
      if (this.searchData.length > 1) {
        this.analytics = this.absoluteData.filter((o) =>
          o.quiz_title.toLowerCase().includes(this.searchData.toLowerCase())
        );
      } else {
        this.analytics = [...this.absoluteData];
      }
    },
    filterAll(d) {
      this.analytics = [...this.absoluteData];
    },
    filterDomain(d) {
      this.analytics = this.absoluteData.filter((o) => o.domain.includes(d));
    },
    filterSubject(d) {
      this.analytics = this.absoluteData.filter((o) =>
        o.quiz_subject.includes(d)
      );
    },
    filterUsageMetric(d){
      this.analytics = this.absoluteData.filter( (o) => o.other.usage_metric == d)
    },
    goToQuestions(quiz_id) {
      this.$router.push({ name: "questions", params: { quiz_id } });
    },
    goToLeaderboard(quiz_id) {
      this.$router.push({ name: "leaderboard-quiz", params: { quiz_id } });
    },
    getAnalytics() {
      this.$upskill.analytics().then((res) => {
        this.absoluteData = res.data.data;
        this.analytics = res.data.data;
        let domainSet = new Set();
        let subjectSet = new Set();
        let usageMetricSet = new Set();
        this.analytics.forEach((o) => {
          o.domain.length > 0 ? domainSet.add(o.domain) : "";
          o.quiz_subject.length > 0 ? subjectSet.add(o.quiz_subject) : "";
          o.other.usage_metric ? usageMetricSet.add(o.other.usage_metric) : "";
        });
        this.domains = Array.from(domainSet);
        this.subjects = Array.from(subjectSet);
        this.usageMetrics = Array.from(usageMetricSet);
      });
    },
    getAnalyticsByInterval() {
      this.$upskill.analyticsByInterval(this.from, this.to).then((res) => {
        this.absoluteData = res.data.data;
        this.analytics = res.data.data;
        let domainSet = new Set();
        let subjectSet = new Set();
        let usageMetricSet = new Set();
        this.analytics.forEach((o) => {
          o.domain.length > 0 ? domainSet.add(o.domain) : "";
          o.quiz_subject.length > 0 ? subjectSet.add(o.quiz_subject) : "";
          o.other.usage_metric ? usageMetricSet.add(o.other.usage_metric) : "";
        });
        this.domains = Array.from(domainSet);
        this.subjects = Array.from(subjectSet);
        this.usageMetrics = Array.from(usageMetricSet);
      });
    },
    getTotalAnalyticsData() {
      this.$upskill
        .analyticsTotal()
        .then((res) => {
          this.totalData = res.data.data;
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped></style>
